module.exports = __webpack_public_path__ + "static/media/cases_brand_jardim_07.eeebc9fc.jpg";